const selectors = {};
class templateCollectionJS {
    constructor() {
        this.init();
    }

    init(){
        if (window.globalVariables.templateSuffix == 'editions-collection') {
            var headerHeight = document.querySelector('.navbar-main').offsetHeight;
            var scrollTab = document.querySelector('.tab-column').offsetHeight;
            document.querySelectorAll('.scroll-padding').forEach(ele=>{ele.style.paddingTop = headerHeight + scrollTab + 'px';})
        }
        // JS code for collection features
    }
}

typeof templateCollectionJS !== 'undefined' && new templateCollectionJS();